import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../utils/supabaseClient'
import { useAuth } from '../context/AuthContext'
import { WatchHistory as WatchHistoryType } from '../types'
import { Box, Typography, List, ListItem, ListItemText, CircularProgress, Alert } from '@mui/material'

const WatchHistoryPage: React.FC = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [history, setHistory] = useState<WatchHistoryType[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (user) fetchHistory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  const fetchHistory = async () => {
    setLoading(true)
    const { data, error } = await supabase
      .from('watch_history')
      .select('*, movie:movies(*)')
      .eq('user_id', user!.id)
      .order('last_watched_at', { ascending: false })
      .limit(50)

    if (!error && data) setHistory(data)
    setLoading(false)
  }

  if (!user) return <Alert severity="warning" sx={{ m: 2 }}>请先登录查看观看记录</Alert>

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
      <Typography variant="h5" sx={{ mb: 2, color: '#fff' }}>观看记录</Typography>
      {history.length === 0 ? (
        <Typography sx={{ color: '#666' }}>暂无观看记录</Typography>
      ) : (
        <List>
          {history.map(h => (
            <ListItem
              key={h.id}
              sx={{ bgcolor: '#1a1a2e', mb: 1, borderRadius: 1, cursor: 'pointer' }}
              onClick={() => navigate(`/movie/${encodeURIComponent(h.movie?.title || '')}`)}
            >
              <ListItemText
                primary={<Typography sx={{ color: '#fff' }}>{h.movie?.title}{h.movie?.episode_number ? ` 第${h.movie.episode_number}集` : ''}</Typography>}
                secondary={<Typography variant="body2" sx={{ color: '#888' }}>{`进度: ${Math.round(h.progress)}% · ${new Date(h.last_watched_at).toLocaleString('zh-CN')}`}</Typography>}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  )
}

export default WatchHistoryPage
